!(function (c) {
  'use strict';
  var t = c.URL || c.webkitURL;
  function f(e) {
    return !!t && t.createObjectURL(e);
  }
  function i(e) {
    return !!t && t.revokeObjectURL(e);
  }
  function u(e, t) {
    !e || 'blob:' !== e.slice(0, 5) || (t && t.noRevoke) || i(e);
  }
  function d(e, t, i, a) {
    if (!c.FileReader) return !1;
    var n = new FileReader();
    (n.onload = function () {
      t.call(n, this.result);
    }),
      i &&
        (n.onabort = n.onerror =
          function () {
            i.call(n, this.error);
          });
    a = n[a || 'readAsDataURL'];
    return a ? (a.call(n, e), n) : void 0;
  }
  function g(e, t) {
    return Object.prototype.toString.call(t) === '[object ' + e + ']';
  }
  function m(s, e, l) {
    function t(i, a) {
      var n,
        r = document.createElement('img');
      function o(e, t) {
        i !== a
          ? e instanceof Error
            ? a(e)
            : (((t = t || {}).image = e), i(t))
          : i && i(e, t);
      }
      function e(e, t) {
        t && c.console && console.log(t),
          e && g('Blob', e)
            ? (n = f((s = e)))
            : ((n = s), l && l.crossOrigin && (r.crossOrigin = l.crossOrigin)),
          (r.src = n);
      }
      return (
        (r.onerror = function (e) {
          u(n, l), a && a.call(r, e);
        }),
        (r.onload = function () {
          u(n, l);
          var e = {
            originalWidth: r.naturalWidth || r.width,
            originalHeight: r.naturalHeight || r.height,
          };
          try {
            m.transform(r, l, o, s, e);
          } catch (t) {
            a && a(t);
          }
        }),
        'string' == typeof s
          ? (m.requiresMetaData(l) ? m.fetchBlob(s, e, l) : e(), r)
          : g('Blob', s) || g('File', s)
          ? (n = f(s))
            ? ((r.src = n), r)
            : d(
                s,
                function (e) {
                  r.src = e;
                },
                a
              )
          : void 0
      );
    }
    return c.Promise && 'function' != typeof e
      ? ((l = e), new Promise(t))
      : t(e, e);
  }
  (m.requiresMetaData = function (e) {
    return e && e.meta;
  }),
    (m.fetchBlob = function (e, t) {
      t();
    }),
    (m.transform = function (e, t, i, a, n) {
      i(e, n);
    }),
    (m.global = c),
    (m.readFile = d),
    (m.isInstanceOf = g),
    (m.createObjectURL = f),
    (m.revokeObjectURL = i),
    'function' == typeof define && define.amd
      ? define(function () {
          return m;
        })
      : 'object' == typeof module && module.exports
      ? (module.exports = m)
      : (c.loadImage = m);
})(('undefined' != typeof window && window) || this),
  (function (e) {
    'use strict';
    'function' == typeof define && define.amd
      ? define(['./load-image'], e)
      : 'object' == typeof module && module.exports
      ? e(require('./load-image'))
      : e(window.loadImage);
  })(function (E) {
    'use strict';
    var r = E.transform;
    (E.createCanvas = function (e, t, i) {
      if (i && E.global.OffscreenCanvas) return new OffscreenCanvas(e, t);
      i = document.createElement('canvas');
      return (i.width = e), (i.height = t), i;
    }),
      (E.transform = function (e, t, i, a, n) {
        r.call(E, E.scale(e, t, n), t, i, a, n);
      }),
      (E.transformCoordinates = function () {}),
      (E.getTransformedOptions = function (e, t) {
        var i,
          a,
          n,
          r = t.aspectRatio;
        if (!r) return t;
        for (a in ((i = {}), t))
          Object.prototype.hasOwnProperty.call(t, a) && (i[a] = t[a]);
        return (
          (i.crop = !0),
          r <
          (n = e.naturalWidth || e.width) / (e = e.naturalHeight || e.height)
            ? ((i.maxWidth = e * r), (i.maxHeight = e))
            : ((i.maxWidth = n), (i.maxHeight = n / r)),
          i
        );
      }),
      (E.drawImage = function (e, t, i, a, n, r, o, s, l) {
        t = t.getContext('2d');
        return (
          !1 === l.imageSmoothingEnabled
            ? ((t.msImageSmoothingEnabled = !1), (t.imageSmoothingEnabled = !1))
            : l.imageSmoothingQuality &&
              (t.imageSmoothingQuality = l.imageSmoothingQuality),
          t.drawImage(e, i, a, n, r, 0, 0, o, s),
          t
        );
      }),
      (E.requiresCanvas = function (e) {
        return e.canvas || e.crop || !!e.aspectRatio;
      }),
      (E.scale = function (e, t, i) {
        (t = t || {}), (i = i || {});
        var a,
          n,
          r,
          o,
          s,
          l,
          c,
          f,
          u,
          d,
          g,
          m =
            e.getContext ||
            (E.requiresCanvas(t) && !!E.global.HTMLCanvasElement),
          h = e.naturalWidth || e.width,
          p = e.naturalHeight || e.height,
          A = h,
          b = p;
        function y() {
          var e = Math.max((r || A) / A, (o || b) / b);
          1 < e && ((A *= e), (b *= e));
        }
        function S() {
          var e = Math.min((a || A) / A, (n || b) / b);
          e < 1 && ((A *= e), (b *= e));
        }
        if (
          (m &&
            ((c = (t = E.getTransformedOptions(e, t, i)).left || 0),
            (f = t.top || 0),
            t.sourceWidth
              ? ((s = t.sourceWidth),
                t.right !== undefined &&
                  t.left === undefined &&
                  (c = h - s - t.right))
              : (s = h - c - (t.right || 0)),
            t.sourceHeight
              ? ((l = t.sourceHeight),
                t.bottom !== undefined &&
                  t.top === undefined &&
                  (f = p - l - t.bottom))
              : (l = p - f - (t.bottom || 0)),
            (A = s),
            (b = l)),
          (a = t.maxWidth),
          (n = t.maxHeight),
          (r = t.minWidth),
          (o = t.minHeight),
          m && a && n && t.crop
            ? (d = s / l - (A = a) / (b = n)) < 0
              ? ((l = (n * s) / a),
                t.top === undefined &&
                  t.bottom === undefined &&
                  (f = (p - l) / 2))
              : 0 < d &&
                ((s = (a * l) / n),
                t.left === undefined &&
                  t.right === undefined &&
                  (c = (h - s) / 2))
            : ((t.contain || t.cover) && ((r = a = a || r), (o = n = n || o)),
              t.cover ? (S(), y()) : (y(), S())),
          m)
        ) {
          if (
            (1 < (m = t.pixelRatio) &&
              (!e.style.width ||
                Math.floor(parseFloat(e.style.width, 10)) !==
                  Math.floor(h / m)) &&
              ((A *= m), (b *= m)),
            E.orientationCropBug &&
              !e.getContext &&
              (c || f || s !== h || l !== p) &&
              ((d = e),
              (e = E.createCanvas(h, p, !0)),
              E.drawImage(d, e, 0, 0, h, p, h, p, t)),
            0 < (u = t.downsamplingRatio) && u < 1 && A < s && b < l)
          )
            for (; A < s * u; )
              (g = E.createCanvas(s * u, l * u, !0)),
                E.drawImage(e, g, c, f, s, l, g.width, g.height, t),
                (f = c = 0),
                (s = g.width),
                (l = g.height),
                (e = g);
          return (
            (g = E.createCanvas(A, b)),
            E.transformCoordinates(g, t, i),
            1 < m && (g.style.width = g.width / m + 'px'),
            E.drawImage(e, g, c, f, s, l, A, b, t).setTransform(
              1,
              0,
              0,
              1,
              0,
              0
            ),
            g
          );
        }
        return (e.width = A), (e.height = b), e;
      });
  }),
  (function (e) {
    'use strict';
    'function' == typeof define && define.amd
      ? define(['./load-image'], e)
      : 'object' == typeof module && module.exports
      ? e(require('./load-image'))
      : e(window.loadImage);
  })(function (o) {
    'use strict';
    var s = o.global,
      l = o.transform,
      a =
        s.Blob &&
        (Blob.prototype.slice ||
          Blob.prototype.webkitSlice ||
          Blob.prototype.mozSlice),
      m =
        (s.ArrayBuffer && ArrayBuffer.prototype.slice) ||
        function (e, t) {
          t = t || this.byteLength - e;
          (e = new Uint8Array(this, e, t)), (t = new Uint8Array(t));
          return t.set(e), t.buffer;
        },
      h = { jpeg: { 65505: [], 65517: [] } };
    function c(t, e, u, d) {
      var g = this;
      function i(c, f) {
        if (!(s.DataView && a && t && 12 <= t.size && 'image/jpeg' === t.type))
          return c(d);
        var e = u.maxMetaDataSize || 262144;
        o.readFile(
          a.call(t, 0, e),
          function (e) {
            var t = new DataView(e);
            if (65496 !== t.getUint16(0))
              return f(new Error('Invalid JPEG file: Missing JPEG marker.'));
            for (
              var i, a, n, r, o = 2, s = t.byteLength - 4, l = o;
              o < s &&
              ((65504 <= (i = t.getUint16(o)) && i <= 65519) || 65534 === i);

            ) {
              if (o + (a = t.getUint16(o + 2) + 2) > t.byteLength) {
                console.log('Invalid JPEG metadata: Invalid segment size.');
                break;
              }
              if ((n = h.jpeg[i]) && !u.disableMetaDataParsers)
                for (r = 0; r < n.length; r += 1) n[r].call(g, t, o, a, d, u);
              l = o += a;
            }
            !u.disableImageHead && 6 < l && (d.imageHead = m.call(e, 0, l)),
              c(d);
          },
          f,
          'readAsArrayBuffer'
        ) || c(d);
      }
      return (
        (u = u || {}),
        s.Promise && 'function' != typeof e
          ? ((d = u = e || {}), new Promise(i))
          : ((d = d || {}), i(e, e))
      );
    }
    function n(e, t, i) {
      return e && t && i
        ? new Blob([i, a.call(e, t.byteLength)], { type: 'image/jpeg' })
        : null;
    }
    (o.transform = function (t, i, a, n, r) {
      o.requiresMetaData(i)
        ? c(
            n,
            function (e) {
              e !== r && (s.console && console.log(e), (e = r)),
                l.call(o, t, i, a, n, e);
            },
            i,
            (r = r || {})
          )
        : l.apply(o, arguments);
    }),
      (o.blobSlice = a),
      (o.bufferSlice = m),
      (o.replaceHead = function (t, i, a) {
        var e = { maxMetaDataSize: 1024, disableMetaDataParsers: !0 };
        if (!a && s.Promise)
          return c(t, e).then(function (e) {
            return n(t, e.imageHead, i);
          });
        c(
          t,
          function (e) {
            a(n(t, e.imageHead, i));
          },
          e
        );
      }),
      (o.parseMetaData = c),
      (o.metaDataParsers = h);
  }),
  (function (e) {
    'use strict';
    'function' == typeof define && define.amd
      ? define(['./load-image'], e)
      : 'object' == typeof module && module.exports
      ? e(require('./load-image'))
      : e(window.loadImage);
  })(function (e) {
    'use strict';
    var r = e.global;
    r.fetch && r.Request && r.Response && r.Response.prototype.blob
      ? (e.fetchBlob = function (e, t, i) {
          function a(e) {
            return e.blob();
          }
          if (r.Promise && 'function' != typeof t)
            return fetch(new Request(e, t)).then(a);
          fetch(new Request(e, i))
            .then(a)
            .then(t)
            ['catch'](function (e) {
              t(null, e);
            });
        })
      : r.XMLHttpRequest &&
        '' === new XMLHttpRequest().responseType &&
        (e.fetchBlob = function (e, t, n) {
          function i(t, i) {
            n = n || {};
            var a = new XMLHttpRequest();
            a.open(n.method || 'GET', e),
              n.headers &&
                Object.keys(n.headers).forEach(function (e) {
                  a.setRequestHeader(e, n.headers[e]);
                }),
              (a.withCredentials = 'include' === n.credentials),
              (a.responseType = 'blob'),
              (a.onload = function () {
                t(a.response);
              }),
              (a.onerror =
                a.onabort =
                a.ontimeout =
                  function (e) {
                    t === i ? i(null, e) : i(e);
                  }),
              a.send(n.body);
          }
          return r.Promise && 'function' != typeof t
            ? ((n = t), new Promise(i))
            : i(t, t);
        });
  }),
  (function (e) {
    'use strict';
    'function' == typeof define && define.amd
      ? define(['./load-image', './load-image-scale', './load-image-meta'], e)
      : 'object' == typeof module && module.exports
      ? e(
          require('./load-image'),
          require('./load-image-scale'),
          require('./load-image-meta')
        )
      : e(window.loadImage);
  })(function (f) {
    'use strict';
    var t,
      i,
      r = f.transform,
      a = f.requiresCanvas,
      n = f.requiresMetaData,
      l = f.transformCoordinates,
      u = f.getTransformedOptions;
    function o(e, t) {
      e = e && e.orientation;
      return (
        (!0 === e && !f.orientation) ||
        (1 === e && f.orientation) ||
        ((!t || f.orientation) && 1 < e && e < 9)
      );
    }
    function d(e, t) {
      return e !== t && ((1 === e && 1 < t && t < 9) || (1 < e && e < 9));
    }
    function g(e, t) {
      if (1 < t && t < 9)
        switch (e) {
          case 2:
          case 4:
            return 4 < t;
          case 5:
          case 7:
            return t % 2 == 0;
          case 6:
          case 8:
            return 2 === t || 4 === t || 5 === t || 7 === t;
        }
    }
    (t = f).global.document &&
      (((i = document.createElement('img')).onload = function () {
        var e;
        (t.orientation = 2 === i.width && 3 === i.height),
          t.orientation &&
            ((e = t.createCanvas(1, 1, !0).getContext('2d')).drawImage(
              i,
              1,
              1,
              1,
              1,
              0,
              0,
              1,
              1
            ),
            (t.orientationCropBug =
              '255,255,255,255' !==
              e.getImageData(0, 0, 1, 1).data.toString()));
      }),
      (i.src =
        'data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAIAAwMBEQACEQEDEQH/xABRAAEAAAAAAAAAAAAAAAAAAAAKEAEBAQADAQEAAAAAAAAAAAAGBQQDCAkCBwEBAAAAAAAAAAAAAAAAAAAAABEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AG8T9NfSMEVMhQvoP3fFiRZ+MTHDifa/95OFSZU5OzRzxkyejv8ciEfhSceSXGjS8eSdLnZc2HDm4M3BxcXwH/9k=')),
      (f.requiresCanvas = function (e) {
        return o(e) || a.call(f, e);
      }),
      (f.requiresMetaData = function (e) {
        return o(e, !0) || n.call(f, e);
      }),
      (f.transform = function (e, t, n, i, a) {
        r.call(
          f,
          e,
          t,
          function (e, t) {
            var i, a;
            !t ||
              (4 < (a = f.orientation && t.exif && t.exif.get('Orientation')) &&
                a < 9 &&
                ((i = t.originalWidth),
                (a = t.originalHeight),
                (t.originalWidth = a),
                (t.originalHeight = i))),
              n(e, t);
          },
          i,
          a
        );
      }),
      (f.getTransformedOptions = function (e, t, i) {
        var a = u.call(f, e, t),
          e = i.exif && i.exif.get('Orientation'),
          t = a.orientation,
          i = f.orientation && e;
        if (!d((t = !0 === t ? e : t), i)) return a;
        var n,
          r = a.top,
          o = a.right,
          s = a.bottom,
          l = a.left,
          c = {};
        for (n in a)
          Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
        if (
          (((4 < (c.orientation = t) && !(4 < i)) || (t < 5 && 4 < i)) &&
            ((c.maxWidth = a.maxHeight),
            (c.maxHeight = a.maxWidth),
            (c.minWidth = a.minHeight),
            (c.minHeight = a.minWidth),
            (c.sourceWidth = a.sourceHeight),
            (c.sourceHeight = a.sourceWidth)),
          1 < i)
        ) {
          switch (i) {
            case 2:
              (o = a.left), (l = a.right);
              break;
            case 3:
              (r = a.bottom), (o = a.left), (s = a.top), (l = a.right);
              break;
            case 4:
              (r = a.bottom), (s = a.top);
              break;
            case 5:
              (r = a.left), (o = a.bottom), (s = a.right), (l = a.top);
              break;
            case 6:
              (r = a.left), (o = a.top), (s = a.right), (l = a.bottom);
              break;
            case 7:
              (r = a.right), (o = a.top), (s = a.left), (l = a.bottom);
              break;
            case 8:
              (r = a.right), (o = a.bottom), (s = a.left), (l = a.top);
          }
          g(t, i) && ((e = r), (i = o), (r = s), (o = l), (s = e), (l = i));
        }
        switch (((c.top = r), (c.right = o), (c.bottom = s), (c.left = l), t)) {
          case 2:
            (c.right = l), (c.left = o);
            break;
          case 3:
            (c.top = s), (c.right = l), (c.bottom = r), (c.left = o);
            break;
          case 4:
            (c.top = s), (c.bottom = r);
            break;
          case 5:
            (c.top = l), (c.right = s), (c.bottom = o), (c.left = r);
            break;
          case 6:
            (c.top = o), (c.right = s), (c.bottom = l), (c.left = r);
            break;
          case 7:
            (c.top = o), (c.right = r), (c.bottom = l), (c.left = s);
            break;
          case 8:
            (c.top = l), (c.right = r), (c.bottom = o), (c.left = s);
        }
        return c;
      }),
      (f.transformCoordinates = function (e, t, i) {
        l.call(f, e, t, i);
        (t = t.orientation),
          (i = f.orientation && i.exif && i.exif.get('Orientation'));
        if (d(t, i)) {
          var a = e.getContext('2d'),
            n = e.width,
            r = e.height,
            o = n,
            s = r;
          switch (
            (((4 < t && !(4 < i)) || (t < 5 && 4 < i)) &&
              ((e.width = r), (e.height = n)),
            4 < t && ((o = r), (s = n)),
            i)
          ) {
            case 2:
              a.translate(o, 0), a.scale(-1, 1);
              break;
            case 3:
              a.translate(o, s), a.rotate(Math.PI);
              break;
            case 4:
              a.translate(0, s), a.scale(1, -1);
              break;
            case 5:
              a.rotate(-0.5 * Math.PI), a.scale(-1, 1);
              break;
            case 6:
              a.rotate(-0.5 * Math.PI), a.translate(-o, 0);
              break;
            case 7:
              a.rotate(-0.5 * Math.PI), a.translate(-o, s), a.scale(1, -1);
              break;
            case 8:
              a.rotate(0.5 * Math.PI), a.translate(0, -s);
          }
          switch ((g(t, i) && (a.translate(o, s), a.rotate(Math.PI)), t)) {
            case 2:
              a.translate(n, 0), a.scale(-1, 1);
              break;
            case 3:
              a.translate(n, r), a.rotate(Math.PI);
              break;
            case 4:
              a.translate(0, r), a.scale(1, -1);
              break;
            case 5:
              a.rotate(0.5 * Math.PI), a.scale(1, -1);
              break;
            case 6:
              a.rotate(0.5 * Math.PI), a.translate(0, -r);
              break;
            case 7:
              a.rotate(0.5 * Math.PI), a.translate(n, -r), a.scale(-1, 1);
              break;
            case 8:
              a.rotate(-0.5 * Math.PI), a.translate(-n, 0);
          }
        }
      });
  }),
  (function (e) {
    'use strict';
    'function' == typeof define && define.amd
      ? define(['./load-image', './load-image-meta'], e)
      : 'object' == typeof module && module.exports
      ? e(require('./load-image'), require('./load-image-meta'))
      : e(window.loadImage);
  })(function (n) {
    'use strict';
    function m(e) {
      e &&
        (Object.defineProperty(this, 'map', { value: this.ifds[e].map }),
        Object.defineProperty(this, 'tags', {
          value: (this.tags && this.tags[e]) || {},
        }));
    }
    (m.prototype.ifds = {
      ifd1: {
        name: 'Thumbnail',
        map: (m.prototype.map = {
          Orientation: 274,
          Thumbnail: 'ifd1',
          Blob: 513,
          Exif: 34665,
          GPSInfo: 34853,
          Interoperability: 40965,
        }),
      },
      34665: { name: 'Exif', map: {} },
      34853: { name: 'GPSInfo', map: {} },
      40965: { name: 'Interoperability', map: {} },
    }),
      (m.prototype.get = function (e) {
        return this[e] || this[this.map[e]];
      });
    var h = {
      1: {
        getValue: function (e, t) {
          return e.getUint8(t);
        },
        size: 1,
      },
      2: {
        getValue: function (e, t) {
          return String.fromCharCode(e.getUint8(t));
        },
        size: 1,
        ascii: !0,
      },
      3: {
        getValue: function (e, t, i) {
          return e.getUint16(t, i);
        },
        size: 2,
      },
      4: {
        getValue: function (e, t, i) {
          return e.getUint32(t, i);
        },
        size: 4,
      },
      5: {
        getValue: function (e, t, i) {
          return e.getUint32(t, i) / e.getUint32(t + 4, i);
        },
        size: 8,
      },
      9: {
        getValue: function (e, t, i) {
          return e.getInt32(t, i);
        },
        size: 4,
      },
      10: {
        getValue: function (e, t, i) {
          return e.getInt32(t, i) / e.getInt32(t + 4, i);
        },
        size: 8,
      },
    };
    function p(e, t, i) {
      return (!e || e[i]) && (!t || !0 !== t[i]);
    }
    function A(e, t, i, a, n, r, o, s) {
      var l, c, f, u, d, g;
      if (i + 6 > e.byteLength)
        console.log('Invalid Exif data: Invalid directory offset.');
      else {
        if (!((c = i + 2 + 12 * (l = e.getUint16(i, a))) + 4 > e.byteLength)) {
          for (f = 0; f < l; f += 1)
            p(o, s, (d = e.getUint16((u = i + 2 + 12 * f), a))) &&
              ((g = (function (e, t, i, a, n, r) {
                var o,
                  s,
                  l,
                  c,
                  f,
                  u = h[a];
                if (u) {
                  if (
                    !(
                      (o =
                        4 < (a = u.size * n)
                          ? t + e.getUint32(i + 8, r)
                          : i + 8) +
                        a >
                      e.byteLength
                    )
                  ) {
                    if (1 === n) return u.getValue(e, o, r);
                    for (s = [], l = 0; l < n; l += 1)
                      s[l] = u.getValue(e, o + l * u.size, r);
                    if (u.ascii) {
                      for (
                        c = '', l = 0;
                        l < s.length && '\0' !== (f = s[l]);
                        l += 1
                      )
                        c += f;
                      return c;
                    }
                    return s;
                  }
                  console.log('Invalid Exif data: Invalid data offset.');
                } else console.log('Invalid Exif data: Invalid tag type.');
              })(e, t, u, e.getUint16(u + 2, a), e.getUint32(u + 4, a), a)),
              (n[d] = g),
              r && (r[d] = u));
          return e.getUint32(c, a);
        }
        console.log('Invalid Exif data: Invalid directory size.');
      }
    }
    (h[7] = h[1]),
      (n.parseExifData = function (l, e, t, c, i) {
        if (!i.disableExif) {
          var f,
            u = i.includeExifTags,
            d = i.excludeExifTags || { 34665: { 37500: !0 } },
            g = e + 10;
          if (1165519206 === l.getUint32(e + 4))
            if (g + 8 > l.byteLength)
              console.log('Invalid Exif data: Invalid segment size.');
            else if (0 === l.getUint16(e + 8)) {
              switch (l.getUint16(g)) {
                case 18761:
                  f = !0;
                  break;
                case 19789:
                  f = !1;
                  break;
                default:
                  return void console.log(
                    'Invalid Exif data: Invalid byte alignment marker.'
                  );
              }
              42 === l.getUint16(g + 2, f)
                ? ((e = l.getUint32(g + 4, f)),
                  (c.exif = new m()),
                  i.disableExifOffsets ||
                    ((c.exifOffsets = new m()),
                    (c.exifTiffOffset = g),
                    (c.exifLittleEndian = f)),
                  (e = A(l, g, g + e, f, c.exif, c.exifOffsets, u, d)) &&
                    p(u, d, 'ifd1') &&
                    ((c.exif.ifd1 = e),
                    c.exifOffsets && (c.exifOffsets.ifd1 = g + e)),
                  Object.keys(c.exif.ifds).forEach(function (e) {
                    var t, i, a, n, r, o, s;
                    (i = e),
                      (a = l),
                      (n = g),
                      (r = f),
                      (o = u),
                      (s = d),
                      (e = (t = c).exif[i]) &&
                        ((t.exif[i] = new m(i)),
                        t.exifOffsets && (t.exifOffsets[i] = new m(i)),
                        A(
                          a,
                          n,
                          n + e,
                          r,
                          t.exif[i],
                          t.exifOffsets && t.exifOffsets[i],
                          o && o[i],
                          s && s[i]
                        ));
                  }),
                  (e = c.exif.ifd1) &&
                    e[513] &&
                    (e[513] = (function (e, t, i) {
                      if (i) {
                        if (!(t + i > e.byteLength))
                          return new Blob(
                            [n.bufferSlice.call(e.buffer, t, t + i)],
                            { type: 'image/jpeg' }
                          );
                        console.log(
                          'Invalid Exif data: Invalid thumbnail data.'
                        );
                      }
                    })(l, g + e[513], e[514])))
                : console.log('Invalid Exif data: Missing TIFF marker.');
            } else
              console.log('Invalid Exif data: Missing byte alignment offset.');
        }
      }),
      n.metaDataParsers.jpeg[65505].push(n.parseExifData),
      (n.exifWriters = {
        274: function (e, t, i) {
          var a = t.exifOffsets[274];
          return (
            a && new DataView(e, a + 8, 2).setUint16(0, i, t.exifLittleEndian),
            e
          );
        },
      }),
      (n.writeExifData = function (e, t, i, a) {
        return n.exifWriters[t.exif.map[i]](e, t, a);
      }),
      (n.ExifMap = m);
  }),
  (function (e) {
    'use strict';
    'function' == typeof define && define.amd
      ? define(['./load-image', './load-image-exif'], e)
      : 'object' == typeof module && module.exports
      ? e(require('./load-image'), require('./load-image-exif'))
      : e(window.loadImage);
  })(function (e) {
    'use strict';
    var n = e.ExifMap.prototype;
    (n.tags = {
      256: 'ImageWidth',
      257: 'ImageHeight',
      258: 'BitsPerSample',
      259: 'Compression',
      262: 'PhotometricInterpretation',
      274: 'Orientation',
      277: 'SamplesPerPixel',
      284: 'PlanarConfiguration',
      530: 'YCbCrSubSampling',
      531: 'YCbCrPositioning',
      282: 'XResolution',
      283: 'YResolution',
      296: 'ResolutionUnit',
      273: 'StripOffsets',
      278: 'RowsPerStrip',
      279: 'StripByteCounts',
      513: 'JPEGInterchangeFormat',
      514: 'JPEGInterchangeFormatLength',
      301: 'TransferFunction',
      318: 'WhitePoint',
      319: 'PrimaryChromaticities',
      529: 'YCbCrCoefficients',
      532: 'ReferenceBlackWhite',
      306: 'DateTime',
      270: 'ImageDescription',
      271: 'Make',
      272: 'Model',
      305: 'Software',
      315: 'Artist',
      33432: 'Copyright',
      34665: {
        36864: 'ExifVersion',
        40960: 'FlashpixVersion',
        40961: 'ColorSpace',
        40962: 'PixelXDimension',
        40963: 'PixelYDimension',
        42240: 'Gamma',
        37121: 'ComponentsConfiguration',
        37122: 'CompressedBitsPerPixel',
        37500: 'MakerNote',
        37510: 'UserComment',
        40964: 'RelatedSoundFile',
        36867: 'DateTimeOriginal',
        36868: 'DateTimeDigitized',
        36880: 'OffsetTime',
        36881: 'OffsetTimeOriginal',
        36882: 'OffsetTimeDigitized',
        37520: 'SubSecTime',
        37521: 'SubSecTimeOriginal',
        37522: 'SubSecTimeDigitized',
        33434: 'ExposureTime',
        33437: 'FNumber',
        34850: 'ExposureProgram',
        34852: 'SpectralSensitivity',
        34855: 'PhotographicSensitivity',
        34856: 'OECF',
        34864: 'SensitivityType',
        34865: 'StandardOutputSensitivity',
        34866: 'RecommendedExposureIndex',
        34867: 'ISOSpeed',
        34868: 'ISOSpeedLatitudeyyy',
        34869: 'ISOSpeedLatitudezzz',
        37377: 'ShutterSpeedValue',
        37378: 'ApertureValue',
        37379: 'BrightnessValue',
        37380: 'ExposureBias',
        37381: 'MaxApertureValue',
        37382: 'SubjectDistance',
        37383: 'MeteringMode',
        37384: 'LightSource',
        37385: 'Flash',
        37396: 'SubjectArea',
        37386: 'FocalLength',
        41483: 'FlashEnergy',
        41484: 'SpatialFrequencyResponse',
        41486: 'FocalPlaneXResolution',
        41487: 'FocalPlaneYResolution',
        41488: 'FocalPlaneResolutionUnit',
        41492: 'SubjectLocation',
        41493: 'ExposureIndex',
        41495: 'SensingMethod',
        41728: 'FileSource',
        41729: 'SceneType',
        41730: 'CFAPattern',
        41985: 'CustomRendered',
        41986: 'ExposureMode',
        41987: 'WhiteBalance',
        41988: 'DigitalZoomRatio',
        41989: 'FocalLengthIn35mmFilm',
        41990: 'SceneCaptureType',
        41991: 'GainControl',
        41992: 'Contrast',
        41993: 'Saturation',
        41994: 'Sharpness',
        41995: 'DeviceSettingDescription',
        41996: 'SubjectDistanceRange',
        42016: 'ImageUniqueID',
        42032: 'CameraOwnerName',
        42033: 'BodySerialNumber',
        42034: 'LensSpecification',
        42035: 'LensMake',
        42036: 'LensModel',
        42037: 'LensSerialNumber',
      },
      34853: {
        0: 'GPSVersionID',
        1: 'GPSLatitudeRef',
        2: 'GPSLatitude',
        3: 'GPSLongitudeRef',
        4: 'GPSLongitude',
        5: 'GPSAltitudeRef',
        6: 'GPSAltitude',
        7: 'GPSTimeStamp',
        8: 'GPSSatellites',
        9: 'GPSStatus',
        10: 'GPSMeasureMode',
        11: 'GPSDOP',
        12: 'GPSSpeedRef',
        13: 'GPSSpeed',
        14: 'GPSTrackRef',
        15: 'GPSTrack',
        16: 'GPSImgDirectionRef',
        17: 'GPSImgDirection',
        18: 'GPSMapDatum',
        19: 'GPSDestLatitudeRef',
        20: 'GPSDestLatitude',
        21: 'GPSDestLongitudeRef',
        22: 'GPSDestLongitude',
        23: 'GPSDestBearingRef',
        24: 'GPSDestBearing',
        25: 'GPSDestDistanceRef',
        26: 'GPSDestDistance',
        27: 'GPSProcessingMethod',
        28: 'GPSAreaInformation',
        29: 'GPSDateStamp',
        30: 'GPSDifferential',
        31: 'GPSHPositioningError',
      },
      40965: { 1: 'InteroperabilityIndex' },
    }),
      (n.tags.ifd1 = n.tags),
      (n.stringValues = {
        ExposureProgram: {
          0: 'Undefined',
          1: 'Manual',
          2: 'Normal program',
          3: 'Aperture priority',
          4: 'Shutter priority',
          5: 'Creative program',
          6: 'Action program',
          7: 'Portrait mode',
          8: 'Landscape mode',
        },
        MeteringMode: {
          0: 'Unknown',
          1: 'Average',
          2: 'CenterWeightedAverage',
          3: 'Spot',
          4: 'MultiSpot',
          5: 'Pattern',
          6: 'Partial',
          255: 'Other',
        },
        LightSource: {
          0: 'Unknown',
          1: 'Daylight',
          2: 'Fluorescent',
          3: 'Tungsten (incandescent light)',
          4: 'Flash',
          9: 'Fine weather',
          10: 'Cloudy weather',
          11: 'Shade',
          12: 'Daylight fluorescent (D 5700 - 7100K)',
          13: 'Day white fluorescent (N 4600 - 5400K)',
          14: 'Cool white fluorescent (W 3900 - 4500K)',
          15: 'White fluorescent (WW 3200 - 3700K)',
          17: 'Standard light A',
          18: 'Standard light B',
          19: 'Standard light C',
          20: 'D55',
          21: 'D65',
          22: 'D75',
          23: 'D50',
          24: 'ISO studio tungsten',
          255: 'Other',
        },
        Flash: {
          0: 'Flash did not fire',
          1: 'Flash fired',
          5: 'Strobe return light not detected',
          7: 'Strobe return light detected',
          9: 'Flash fired, compulsory flash mode',
          13: 'Flash fired, compulsory flash mode, return light not detected',
          15: 'Flash fired, compulsory flash mode, return light detected',
          16: 'Flash did not fire, compulsory flash mode',
          24: 'Flash did not fire, auto mode',
          25: 'Flash fired, auto mode',
          29: 'Flash fired, auto mode, return light not detected',
          31: 'Flash fired, auto mode, return light detected',
          32: 'No flash function',
          65: 'Flash fired, red-eye reduction mode',
          69: 'Flash fired, red-eye reduction mode, return light not detected',
          71: 'Flash fired, red-eye reduction mode, return light detected',
          73: 'Flash fired, compulsory flash mode, red-eye reduction mode',
          77: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected',
          79: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light detected',
          89: 'Flash fired, auto mode, red-eye reduction mode',
          93: 'Flash fired, auto mode, return light not detected, red-eye reduction mode',
          95: 'Flash fired, auto mode, return light detected, red-eye reduction mode',
        },
        SensingMethod: {
          1: 'Undefined',
          2: 'One-chip color area sensor',
          3: 'Two-chip color area sensor',
          4: 'Three-chip color area sensor',
          5: 'Color sequential area sensor',
          7: 'Trilinear sensor',
          8: 'Color sequential linear sensor',
        },
        SceneCaptureType: {
          0: 'Standard',
          1: 'Landscape',
          2: 'Portrait',
          3: 'Night scene',
        },
        SceneType: { 1: 'Directly photographed' },
        CustomRendered: { 0: 'Normal process', 1: 'Custom process' },
        WhiteBalance: { 0: 'Auto white balance', 1: 'Manual white balance' },
        GainControl: {
          0: 'None',
          1: 'Low gain up',
          2: 'High gain up',
          3: 'Low gain down',
          4: 'High gain down',
        },
        Contrast: { 0: 'Normal', 1: 'Soft', 2: 'Hard' },
        Saturation: { 0: 'Normal', 1: 'Low saturation', 2: 'High saturation' },
        Sharpness: { 0: 'Normal', 1: 'Soft', 2: 'Hard' },
        SubjectDistanceRange: {
          0: 'Unknown',
          1: 'Macro',
          2: 'Close view',
          3: 'Distant view',
        },
        FileSource: { 3: 'DSC' },
        ComponentsConfiguration: {
          0: '',
          1: 'Y',
          2: 'Cb',
          3: 'Cr',
          4: 'R',
          5: 'G',
          6: 'B',
        },
        Orientation: {
          1: 'Original',
          2: 'Horizontal flip',
          3: 'Rotate 180° CCW',
          4: 'Vertical flip',
          5: 'Vertical flip + Rotate 90° CW',
          6: 'Rotate 90° CW',
          7: 'Horizontal flip + Rotate 90° CW',
          8: 'Rotate 90° CCW',
        },
      }),
      (n.getText = function (e) {
        var t = this.get(e);
        switch (e) {
          case 'LightSource':
          case 'Flash':
          case 'MeteringMode':
          case 'ExposureProgram':
          case 'SensingMethod':
          case 'SceneCaptureType':
          case 'SceneType':
          case 'CustomRendered':
          case 'WhiteBalance':
          case 'GainControl':
          case 'Contrast':
          case 'Saturation':
          case 'Sharpness':
          case 'SubjectDistanceRange':
          case 'FileSource':
          case 'Orientation':
            return this.stringValues[e][t];
          case 'ExifVersion':
          case 'FlashpixVersion':
            return t ? String.fromCharCode(t[0], t[1], t[2], t[3]) : void 0;
          case 'ComponentsConfiguration':
            return t
              ? this.stringValues[e][t[0]] +
                  this.stringValues[e][t[1]] +
                  this.stringValues[e][t[2]] +
                  this.stringValues[e][t[3]]
              : void 0;
          case 'GPSVersionID':
            return t ? t[0] + '.' + t[1] + '.' + t[2] + '.' + t[3] : void 0;
        }
        return String(t);
      }),
      (n.getAll = function () {
        var e,
          t,
          i = {};
        for (e in this)
          Object.prototype.hasOwnProperty.call(this, e) &&
            ((t = this[e]) && t.getAll
              ? (i[this.ifds[e].name] = t.getAll())
              : (t = this.tags[e]) && (i[t] = this.getText(t)));
        return i;
      }),
      (n.getName = function (e) {
        var t = this.tags[e];
        return 'object' == typeof t ? this.ifds[e].name : t;
      }),
      (function () {
        var e,
          t,
          i,
          a = n.tags;
        for (e in a)
          if (Object.prototype.hasOwnProperty.call(a, e))
            if ((t = n.ifds[e]))
              for (e in (i = a[e]))
                Object.prototype.hasOwnProperty.call(i, e) &&
                  (t.map[i[e]] = Number(e));
            else n.map[a[e]] = Number(e);
      })();
  }),
  (function (e) {
    'use strict';
    'function' == typeof define && define.amd
      ? define(['./load-image', './load-image-meta'], e)
      : 'object' == typeof module && module.exports
      ? e(require('./load-image'), require('./load-image-meta'))
      : e(window.loadImage);
  })(function (e) {
    'use strict';
    function l() {}
    function u(e, t, i, a, n) {
      return 'binary' === t.types[e]
        ? new Blob([i.buffer.slice(a, a + n)])
        : 'Uint16' === t.types[e]
        ? i.getUint16(a)
        : (function (e, t, i) {
            for (var a = '', n = t + i, r = t; r < n; r += 1)
              a += String.fromCharCode(e.getUint8(r));
            return a;
          })(i, a, n);
    }
    function c(e, t, i, a, n, r) {
      for (var o, s, l, c = t + i, f = t; f < c; )
        28 === e.getUint8(f) &&
          2 === e.getUint8(f + 1) &&
          ((o = e.getUint8(f + 2)),
          (n && !n[o]) ||
            (r && r[o]) ||
            ((s = e.getInt16(f + 3)),
            (l = u(o, a.iptc, e, f + 5, s)),
            (a.iptc[o] =
              ((s = a.iptc[o]),
              (l = l),
              s === undefined
                ? l
                : s instanceof Array
                ? (s.push(l), s)
                : [s, l])),
            a.iptcOffsets && (a.iptcOffsets[o] = f))),
          (f += 1);
    }
    (l.prototype.map = { ObjectName: 5 }),
      (l.prototype.types = {
        0: 'Uint16',
        200: 'Uint16',
        201: 'Uint16',
        202: 'binary',
      }),
      (l.prototype.get = function (e) {
        return this[e] || this[this.map[e]];
      }),
      (e.parseIptcData = function (e, t, i, a, n) {
        if (!n.disableIptc)
          for (var r = t + i; t + 8 < r; ) {
            if (
              ((o = t),
              943868237 === (s = e).getUint32(o) && 1028 === s.getUint16(o + 4))
            ) {
              var o =
                  ((o = t),
                  (s = (s = e).getUint8(o + 7)) % 2 != 0 && (s += 1),
                  (s = 0 === s ? 4 : s)),
                s = t + 8 + o;
              if (r < s) {
                console.log('Invalid IPTC data: Invalid segment offset.');
                break;
              }
              o = e.getUint16(t + 6 + o);
              if (r < t + o) {
                console.log('Invalid IPTC data: Invalid segment size.');
                break;
              }
              return (
                (a.iptc = new l()),
                n.disableIptcOffsets || (a.iptcOffsets = new l()),
                void c(
                  e,
                  s,
                  o,
                  a,
                  n.includeIptcTags,
                  n.excludeIptcTags || { 202: !0 }
                )
              );
            }
            t += 1;
          }
      }),
      e.metaDataParsers.jpeg[65517].push(e.parseIptcData),
      (e.IptcMap = l);
  }),
  (function (e) {
    'use strict';
    'function' == typeof define && define.amd
      ? define(['./load-image', './load-image-iptc'], e)
      : 'object' == typeof module && module.exports
      ? e(require('./load-image'), require('./load-image-iptc'))
      : e(window.loadImage);
  })(function (e) {
    'use strict';
    var a = e.IptcMap.prototype;
    (a.tags = {
      0: 'ApplicationRecordVersion',
      3: 'ObjectTypeReference',
      4: 'ObjectAttributeReference',
      5: 'ObjectName',
      7: 'EditStatus',
      8: 'EditorialUpdate',
      10: 'Urgency',
      12: 'SubjectReference',
      15: 'Category',
      20: 'SupplementalCategories',
      22: 'FixtureIdentifier',
      25: 'Keywords',
      26: 'ContentLocationCode',
      27: 'ContentLocationName',
      30: 'ReleaseDate',
      35: 'ReleaseTime',
      37: 'ExpirationDate',
      38: 'ExpirationTime',
      40: 'SpecialInstructions',
      42: 'ActionAdvised',
      45: 'ReferenceService',
      47: 'ReferenceDate',
      50: 'ReferenceNumber',
      55: 'DateCreated',
      60: 'TimeCreated',
      62: 'DigitalCreationDate',
      63: 'DigitalCreationTime',
      65: 'OriginatingProgram',
      70: 'ProgramVersion',
      75: 'ObjectCycle',
      80: 'Byline',
      85: 'BylineTitle',
      90: 'City',
      92: 'Sublocation',
      95: 'State',
      100: 'CountryCode',
      101: 'Country',
      103: 'OriginalTransmissionReference',
      105: 'Headline',
      110: 'Credit',
      115: 'Source',
      116: 'CopyrightNotice',
      118: 'Contact',
      120: 'Caption',
      121: 'LocalCaption',
      122: 'Writer',
      125: 'RasterizedCaption',
      130: 'ImageType',
      131: 'ImageOrientation',
      135: 'LanguageIdentifier',
      150: 'AudioType',
      151: 'AudioSamplingRate',
      152: 'AudioSamplingResolution',
      153: 'AudioDuration',
      154: 'AudioOutcue',
      184: 'JobID',
      185: 'MasterDocumentID',
      186: 'ShortDocumentID',
      187: 'UniqueDocumentID',
      188: 'OwnerID',
      200: 'ObjectPreviewFileFormat',
      201: 'ObjectPreviewFileVersion',
      202: 'ObjectPreviewData',
      221: 'Prefs',
      225: 'ClassifyState',
      228: 'SimilarityIndex',
      230: 'DocumentNotes',
      231: 'DocumentHistory',
      232: 'ExifCameraInfo',
      255: 'CatalogSets',
    }),
      (a.stringValues = {
        10: {
          0: '0 (reserved)',
          1: '1 (most urgent)',
          2: '2',
          3: '3',
          4: '4',
          5: '5 (normal urgency)',
          6: '6',
          7: '7',
          8: '8 (least urgent)',
          9: '9 (user-defined priority)',
        },
        75: { a: 'Morning', b: 'Both Morning and Evening', p: 'Evening' },
        131: { L: 'Landscape', P: 'Portrait', S: 'Square' },
      }),
      (a.getText = function (e) {
        var t = this.get(e),
          e = this.map[e],
          e = this.stringValues[e];
        return e ? e[t] : String(t);
      }),
      (a.getAll = function () {
        var e,
          t,
          i = {};
        for (e in this)
          Object.prototype.hasOwnProperty.call(this, e) &&
            (t = this.tags[e]) &&
            (i[t] = this.getText(t));
        return i;
      }),
      (a.getName = function (e) {
        return this.tags[e];
      }),
      (function () {
        var e,
          t = a.tags,
          i = a.map || {};
        for (e in t)
          Object.prototype.hasOwnProperty.call(t, e) && (i[t[e]] = Number(e));
      })();
  });
//# sourceMappingURL=load-image.all.min.js.map
